import * as React from 'react';
export const LCSvg = React.forwardRef(function LCSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#45B2E8',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'm8 2-5 8h10z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'm8 4-4 6h8z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'm8 7-5 3h10z',
      }),
    ),
  );
});
LCSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var LC = {
  category: 'flag',
  colorable: false,
  name: 'LC',
  svg: LCSvg,
};
